import { Outlet } from 'react-router-dom';
import Footer from '@/components/organisms/Footer';
import { SidebarProvider } from '../atoms/Sidebar';
import { AppSidebar } from '../organisms/AppSidebar';
import { useDetectMobile } from '@/hooks/useDetectMobile';
import { getCookie } from '@/utils/cookies';
import { AppNavbar } from '../organisms/AppNavbar';
import { SidebarInset } from '../atoms/Sidebar';
import { useLocalStorage } from 'usehooks-ts';
import { InstallBanner } from '../organisms/InstallBanner';
import ScrollToTop from '@/routes/ScrollToTop';

type RootlayoutProps = {
  isViewFooter?: boolean;
  bgColor?: string;
};

const PCRootLayout = ({ bgColor = 'bg-gr-50', isViewFooter = false }: RootlayoutProps) => {
  const defaultOpen = getCookie('sidebar_state') === 'true' ? true : false;

  return (
    <div className="flex h-[100dvh] flex-col">
      <ScrollToTop />

      <div className="flex flex-1">
        <SidebarProvider
          style={{
            ['--sidebar-width' as any]: '220px',
            // ['--sidebar-top' as any]: isBannerVisible ? '48px' : '0px',
            ['--sidebar-top' as any]: '0px',
          }}
          className="h-full bg-white transition-all duration-300"
          defaultOpen={true}
        >
          {/* height 계산된 사이드바 */}
          <div className="">
            <AppSidebar />
          </div>
          <SidebarInset>
            {/* 메인 컨텐츠 */}
            <div className={`z-[5] flex h-full w-full flex-col    bg-gr-50`}>
              <AppNavbar />
              <div className="flex h-full w-full">
                <Outlet />
              </div>
              {isViewFooter && <Footer />}
            </div>
          </SidebarInset>
        </SidebarProvider>
      </div>
    </div>
  );
};

export default PCRootLayout;
